import { all, call, put, takeLatest } from "redux-saga/effects";
import AnnouncementService from "../../services/announcement.service";
import {
  getAnnouncementsSuccess,
  getAnnouncementsFailed,
  getAnnouncementDetailsSuccess,
  getAnnouncementDetailsFailed,
  createAnnouncementSuccess,
  createAnnouncementFailed,
  updateAnnouncementSuccess,
  updateAnnouncementFailed,
  deleteAnnouncementSuccess,
  deleteAnnouncementFailed,
  getAnnouncementStatsSuccess,
  getAnnouncementStatsFailed,
  resetAnnouncementRecipientsSuccess,
  resetAnnouncementRecipientsFailed,
} from "./announcementSlice";
import { showErrorToaster, showSuccessToaster } from "../../helpers/utils/toaster";

function* announcementWatcher() {
  yield takeLatest("announcement/getAnnouncements", getAnnouncementsSaga);
  yield takeLatest("announcement/getAnnouncementDetails", getAnnouncementDetailsSaga);
  yield takeLatest("announcement/createAnnouncement", createAnnouncementSaga);
  yield takeLatest("announcement/updateAnnouncement", updateAnnouncementSaga);
  yield takeLatest("announcement/deleteAnnouncement", deleteAnnouncementSaga);
  yield takeLatest("announcement/getAnnouncementStats", getAnnouncementStatsSaga);
  yield takeLatest("announcement/resetAnnouncementRecipients", resetAnnouncementRecipientsSaga);
}

function* getAnnouncementsSaga(action) {
  try {
    const response = yield call(AnnouncementService.getAnnouncements, action.payload);
    if (response?.status) {
      yield put(getAnnouncementsSuccess(response.data));
    } else {
      yield put(getAnnouncementsFailed(response?.message));
    }
  } catch (err) {
    console.error("Error in getAnnouncementsSaga:", err);
    yield put(getAnnouncementsFailed(err?.response?.data?.message || err?.message));
  }
}

function* getAnnouncementDetailsSaga(action) {
  try {
    const response = yield call(AnnouncementService.getAnnouncementDetails, action.payload);
    if (response?.status) {
      yield put(getAnnouncementDetailsSuccess(response.data));
    } else {
      yield put(getAnnouncementDetailsFailed(response?.message));
    }
  } catch (err) {
    console.error("Error in getAnnouncementDetailsSaga:", err);
    yield put(getAnnouncementDetailsFailed(err?.response?.data?.message || err?.message));
  }
}

function* createAnnouncementSaga(action) {
  try {
    const response = yield call(AnnouncementService.createAnnouncement, action.payload);
    if (response?.status) {
      yield put(createAnnouncementSuccess(response.data));
      showSuccessToaster(response.message || "Announcement created successfully");
    } else {
      yield put(createAnnouncementFailed(response?.message));
      showErrorToaster(response?.message || "Failed to create announcement");
    }
  } catch (err) {
    console.error("Error in createAnnouncementSaga:", err);
    const msg = err?.response?.data?.message || err?.message || "Failed to create announcement";
    yield put(createAnnouncementFailed(msg));
    showErrorToaster(msg);
  }
}

function* updateAnnouncementSaga(action) {
  try {
    const response = yield call(AnnouncementService.updateAnnouncement, action.payload);
    if (response?.status) {
      yield put(updateAnnouncementSuccess(response.data));
      showSuccessToaster(response.message || "Announcement updated successfully");
    } else {
      yield put(updateAnnouncementFailed(response?.message));
      showErrorToaster(response?.message || "Failed to update announcement");
    }
  } catch (err) {
    console.error("Error in updateAnnouncementSaga:", err);
    const msg = err?.response?.data?.message || err?.message || "Failed to update announcement";
    yield put(updateAnnouncementFailed(msg));
    showErrorToaster(msg);
  }
}

function* deleteAnnouncementSaga(action) {
  try {
    const response = yield call(AnnouncementService.deleteAnnouncement, action.payload);
    if (response?.status) {
      yield put(deleteAnnouncementSuccess(action.payload));
      showSuccessToaster(response.message || "Announcement deleted successfully");
    } else {
      yield put(deleteAnnouncementFailed(response?.message));
      showErrorToaster(response?.message || "Failed to delete announcement");
    }
  } catch (err) {
    console.error("Error in deleteAnnouncementSaga:", err);
    const msg = err?.response?.data?.message || err?.message || "Failed to delete announcement";
    yield put(deleteAnnouncementFailed(msg));
    showErrorToaster(msg);
  }
}

function* getAnnouncementStatsSaga(action) {
  try {
    const response = yield call(AnnouncementService.getAnnouncementStats, action.payload);
    if (response?.status) {
      yield put(getAnnouncementStatsSuccess(response.data));
    } else {
      yield put(getAnnouncementStatsFailed(response?.message));
      showErrorToaster(response?.message || "Failed to get stats");
    }
  } catch (err) {
    console.error("Error in getAnnouncementStatsSaga:", err);
    const msg = err?.response?.data?.message || err?.message || "Failed to get stats";
    yield put(getAnnouncementStatsFailed(msg));
    showErrorToaster(msg);
  }
}

function* resetAnnouncementRecipientsSaga(action) {
  try {
    const response = yield call(AnnouncementService.resetRecipients, action.payload);
    if (response?.status) {
      yield put(resetAnnouncementRecipientsSuccess());
      showSuccessToaster(response.message || "Recipients reset successfully");
    } else {
      yield put(resetAnnouncementRecipientsFailed(response?.message));
      showErrorToaster(response?.message || "Failed to reset recipients");
    }
  } catch (err) {
    console.error("Error in resetAnnouncementRecipientsSaga:", err);
    const msg = err?.response?.data?.message || err?.message || "Failed to reset recipients";
    yield put(resetAnnouncementRecipientsFailed(msg));
    showErrorToaster(msg);
  }
}

export default function* announcementSaga() {
  yield all([announcementWatcher()]);
}
